import styled from '@emotion/styled';

import { COLORS3, FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';

import Chip from '@zola/zola-ui/src/components/Chip';

export const StyledChip = styled(Chip)`
  padding: ${SPACING.MD} ${SPACING.S16};
  display: flex;
  text-align: left;
  align-content: start;

  ${MEDIA_QUERY.DESKTOP} {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: ${SPACING.XS};
  }
`;

export const Hed = styled.div`
  ${FONT.textSizeCompact(FONT.SIZE.SMALL)}
`;

export const Dek = styled.div`
  ${FONT.textSizeCompact(FONT.SIZE.EXTRA_SMALL)}
  color: ${COLORS3.BLACK_075};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${SPACING.XS};
  margin-bottom: ${SPACING.S16};

  ${MEDIA_QUERY.DESKTOP} {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export const IconContainer = styled.div`
  flex: 0 0 auto;
`;

export const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${SPACING.XS};

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    margin-left: ${SPACING.XS};
    grid-gap: 0;
  }
`;

export const ValuePropsImg = styled.img`
  position: absolute;
  left: 50%;
  margin-left: -50px;
  top: 340px;
`;
